Vue.component('my-tabs', {
    template: '#tabs',
    delimiters: ['[[', ']]'],
    data: function() {
        return {
            tabs: [],
            current: null
        };
    },
    methods: {
        addTab: function(tab) {
            this.tabs.push(tab);
            if (tab.active === true) {
                this.current = tab;
            }
        },
        changeTab: function(tab) {
            this.current = tab;
            this.tabs.forEach(function(value) {
                if (value === tab) {
                    value.active = true;
                } else {
                    value.active = false;
                }
            });
        }
    }
});
